var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex"},[_c('b-icon',{staticClass:"mr-2",class:_vm.iconClass,attrs:{"icon":_vm.icon,"size":"is-small"}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }